import React from 'react';

// Full page spinner
export function PageLoader({ C, message = 'Loading...' }) {
  return (
    <div style={{
      display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',
      padding:'60px 20px',minHeight:'40vh',
    }}>
      <div style={{
        width:40,height:40,
        border:`3px solid ${C?.border||'#e5e5e5'}`,
        borderTop:`3px solid ${C?.primary||'#1a3cc8'}`,
        borderRadius:'50%',
        animation:'spin 0.8s linear infinite',
        marginBottom:14,
      }}/>
      <div style={{fontSize:12,color:C?.muted||'#9ca3af',fontWeight:500}}>{message}</div>
    </div>
  );
}

// Inline spinner (small)
export function Spinner({ size=20, color='#1a3cc8', C }) {
  return (
    <div style={{
      width:size,height:size,
      border:`2px solid ${C?.border||'#e5e5e5'}`,
      borderTop:`2px solid ${color}`,
      borderRadius:'50%',
      animation:'spin 0.8s linear infinite',
      display:'inline-block',
    }}/>
  );
}

// Skeleton for cards
export function SkeletonCard({ C, count=1, height=80 }) {
  return (
    <>
      {Array(count).fill(0).map((_,i)=>(
        <div key={i} style={{
          background:`linear-gradient(90deg, ${C?.card||'#f3f4f6'} 0%, ${C?.input||'#e5e5e5'} 50%, ${C?.card||'#f3f4f6'} 100%)`,
          backgroundSize:'200% 100%',
          borderRadius:14,
          height:height,
          marginBottom:10,
          animation:'shimmer 1.5s infinite linear',
        }}/>
      ))}
    </>
  );
}

// Skeleton for list items (with image + text)
export function SkeletonList({ C, count=3 }) {
  return (
    <>
      {Array(count).fill(0).map((_,i)=>(
        <div key={i} style={{
          background:C?.card||'#fff',
          border:`1px solid ${C?.border||'#e5e5e5'}`,
          borderRadius:14,padding:14,marginBottom:10,
          display:'flex',alignItems:'center',gap:12,
        }}>
          <div style={{
            width:40,height:40,borderRadius:10,
            background:C?.input||'#f3f4f6',
            animation:'pulse 1.5s infinite',
          }}/>
          <div style={{flex:1}}>
            <div style={{
              height:12,borderRadius:4,
              background:C?.input||'#f3f4f6',
              width:'70%',marginBottom:6,
              animation:'pulse 1.5s infinite',
            }}/>
            <div style={{
              height:10,borderRadius:4,
              background:C?.input||'#f3f4f6',
              width:'50%',
              animation:'pulse 1.5s infinite',
            }}/>
          </div>
        </div>
      ))}
    </>
  );
}

// Error state
export function ErrorState({ C, message='Something went wrong', onRetry }) {
  return (
    <div style={{
      textAlign:'center',padding:'40px 20px',
      background:C?.card||'#fff',borderRadius:14,
      border:`1px solid ${C?.border||'#e5e5e5'}`,
    }}>
      <div style={{fontSize:40,marginBottom:10}}>⚠️</div>
      <div style={{fontSize:14,color:C?.text||'#000',fontWeight:600,marginBottom:6}}>{message}</div>
      {onRetry && (
        <button onClick={onRetry} style={{
          marginTop:10,
          background:C?.primary||'#1a3cc8',border:'none',
          borderRadius:10,padding:'8px 20px',color:'#fff',
          fontSize:12,fontWeight:700,cursor:'pointer',
        }}>
          Try Again
        </button>
      )}
    </div>
  );
}

// Empty state
export function EmptyState({ C, icon='📋', title='No data', message='', action }) {
  return (
    <div style={{
      textAlign:'center',padding:'40px 20px',
      background:C?.card||'#fff',borderRadius:14,
      border:`1px solid ${C?.border||'#e5e5e5'}`,
    }}>
      <div style={{fontSize:48,marginBottom:10}}>{icon}</div>
      <div style={{fontSize:15,color:C?.text||'#000',fontWeight:700,marginBottom:6}}>{title}</div>
      {message && <div style={{fontSize:12,color:C?.muted||'#9ca3af',marginBottom:16}}>{message}</div>}
      {action}
    </div>
  );
}
